<template>
  <div class="SectionPersonelSearchPanel">
    <box class="" :title="this.$t('search')">
      <div class="px-3 pt-2">
        <v-row>
          <v-col>
            <div>
              <table>
                <tbody>
                  <tr>
                    <td>
                      <label>{{ $t("fromDate") }} : </label>
                    </td>
                    <td>
                      <div>
                        <dialog-date-picker
                          :label="$t('fromDate') + ':'"
                          :initDate="initBeginDate"
                          @dateResult="bDate"
                        />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label>{{ $t("toDate") }} : </label>
                    </td>
                    <td>
                      <div>
                        <dialog-date-picker
                          :label="$t('toDate') + ':'"
                          :initDate="initEndDate"
                          @dateResult="eDate"
                        />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label for="personelByName"
                        >{{ $t("personelByName") }}:
                      </label>
                    </td>
                    <td>
                      <div>
                        <v-select
                          hide-details
                          v-model="personel"
                          :items="personelList"
                          :label="$t('personelByName')"
                          item-text="PersonName"
                          item-value="PERNO"
                          return-object
                          dense
                          solo
                          v-on:change="changePersonelByName"
                          class="my-auto py-0"
                        ></v-select>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label for="personelByPerno"
                        >{{ $t("personelByPerno") }}:
                      </label>
                    </td>
                    <td>
                      <div>
                        <v-text-field
                          hide-details
                          v-model.lazy="personelPerno"
                          :label="$t('personelByPerno')"
                          @change="changePersonelPerno"
                          dense
                          solo
                          class="my-auto py-0"
                        ></v-text-field>
                      </div>
                    </td>
                  </tr>
                  
                </tbody>
              </table>
            </div>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="primary" @click="search">{{ $t("search") }}</v-btn>
        </v-card-actions>
      </div>
    </box>
  </div>
</template>

<script>
import ResultType from "../../model/ResultType";
import DialogDatePicker from "../widget/DialogDatePicker.vue";
export default {
  props: {
    accessTo: Number,
  },
  components: { DialogDatePicker },
  data() {
    return {
     
      initBeginDate: null,
      beginDate: "",
      initEndDate: null,
      endDate: "",
      personelList: [],
      personel: {},
      personelPerno: "",
    };
  },
  mounted() {
    this.getPersonelList();
  },

  methods: {
    bDate(date) {
      this.beginDate = date;
    },
    eDate(date) {
      this.endDate = date;
    },
    getPersonelList() {
      var permissionNumber = this.accessTo
      this.$store.dispatch("GetAccessPersonList",{permissionNumber}).then((result) => {
        //console.log(result);
        if (result.type == ResultType.success) {
          this.personelList = result.data;
          if (this.personelList.length > 0) {
            this.personel = this.personelList[0];
            this.personelPerno = this.personel.PerNo.trim();
          }
        }
      });
    },
    
    changePersonelByName() {
      this.personelPerno = this.personel.PerNo.trim();
      this.search();
    },
    changePersonelPerno() {
      var personel = this.personelList.find(
        (item) => item.PerNo.trim() == this.personelPerno
      );
      if (personel) {
        this.personel = personel;
      } else {
        this.personel = "";
      }
      this.search();
    },
    search() {
      var perno = "-1";
      if (this.personel && this.personel?.PerNo.trim()) {
        perno = this.personel?.PerNo.trim();
      } else if (this.personelPerno) {
        perno = this.personelPerno;
      }

      var searchParams = {
        beginDate: this.beginDate,
        endDate: this.endDate,
        perno: perno,
      };

      this.$emit("search", searchParams);
    },
  },
};
</script>

<style scoped>
.v-input--selection-controls {
  margin: 0;
}

::v-deep .management-checkbox .v-label {
  font-size: 0.9rem;
  text-align: right;
}
</style>